import { render, staticRenderFns } from "./ResumeUpload.vue?vue&type=template&id=42fa5874&scoped=true&"
import script from "./ResumeUpload.vue?vue&type=script&lang=js&"
export * from "./ResumeUpload.vue?vue&type=script&lang=js&"
import style0 from "./ResumeUpload.vue?vue&type=style&index=0&id=42fa5874&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fa5874",
  null
  
)

export default component.exports